module.exports = global["$"] = require("-!/Users/plexen/workspace/wcoi.org/node_modules/expose-loader/index.js?jQuery!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/expose-loader?$!./node_modules/expose-loader?jQuery!./public/assets/libs/jquery/dist/jquery.js-exposed
// module id = 14
// module chunks = 0